import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:4000/api';

export function getCartToken() {
  let token = localStorage.getItem('cart_token');
  if (!token) {
    token = 'cart-' + Math.random().toString(36).slice(2) + Date.now();
    localStorage.setItem('cart_token', token);
  }
  return token;
}

const client = axios.create({ baseURL: API_BASE });

export default {
  getProducts: () => client.get('/products').then(r => r.data),
  getProduct: (id) => client.get(`/products/${id}`).then(r => r.data),
  getTestimonials: (productId) => client.get(`/products/${productId}/testimonials`).then(r => r.data),

  getCart: () => client.get(`/cart/${getCartToken()}`).then(r => r.data),
  getAllTestimonials: () => client.get('/testimonials').then(r => r.data),
  addToCart: (productId, licenseType, quantity = 1) =>
    client.post(`/cart/${getCartToken()}/items`, { productId, licenseType, quantity }).then(r => r.data),
  updateCartItem: (itemId, quantity) =>
    client.patch(`/cart/${getCartToken()}/items/${itemId}`, { quantity }).then(r => r.data),
  removeCartItem: (itemId) =>
    client.delete(`/cart/${getCartToken()}/items/${itemId}`),

  checkout: (email, provider) =>
    client.post('/orders/checkout', { cartToken: getCartToken(), email, provider }).then(r => r.data),
  getOrderStatus: (reference) => client.get(`/orders/${reference}`).then(r => r.data)
};
